class PersonalStorageKeys {
  UserEmail = "personal_i_email";
  PASSWORD = "personal_i_password";
  BIBLEVERSE = "personal_i_bibleText";
  UserHighlight = "personal_i_Highlight";
  UserData = "personal_u_userdata";
  UserComment = "personal_u_comment";
  UserName = "personal_i_username";
  UserIntroduction = "personal_u_introduction";
  UserCountry = "personal_u_country";
  UserReligion = "personal_u_religion";
  UserQuotes = "personal_u_quotes";
  PictureBackground = "personal_p_formData_background";
  PictureProfile = "personal_p_formData_profile";
  PictureName = "personal_p_Name";
  EMAIL = "personal_u_email";
  SupabaseUrlProfile =
    "https://kbuzjqfgjvrgbivzbxjb.supabase.co/storage/v1/object/public/tanyapendeta%20bucket/profile_";
}
export default new PersonalStorageKeys();
